export default class GetProductCalculationsError extends Error {
  constructor(message: string, readonly productId: string) {
    super(message);
  }
}
